import {
  GISSTANDINCONSISTENCY_FIELDS,
  GISSTANDINCONSISTENCY_MENU_CATEGORY,
  GISSTANDINCONSISTENCY_MENU_SUBCATEGORY,
  GISSTANDINCONSISTENCY_PERMISSION,
} from '../gis-stand-inconsistency/gis-stand-inconsistency.config';

export const GISSTANDINCONSISTENCYDISABLEDINZENDRA_FIELDS = GISSTANDINCONSISTENCY_FIELDS;

export const GISSTANDINCONSISTENCYDISABLEDINZENDRA_CONFIG = {
  entityName: 'GisStandInconsistencyDisabledInZendra',
  localizationKey: 'Geographic::Entity.GisStandInconsistency.DisabledInZendra',
  fields: GISSTANDINCONSISTENCYDISABLEDINZENDRA_FIELDS,
  permission: GISSTANDINCONSISTENCY_PERMISSION,
  showInMenu: false,
  menuCategory: GISSTANDINCONSISTENCY_MENU_CATEGORY,
  menuSubcategory: GISSTANDINCONSISTENCY_MENU_SUBCATEGORY,
};